import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

@Component({
  selector: 'app-settings-layout',
  imports: [RouterOutlet],
  templateUrl: './settings-layout.html',
  styleUrl: './settings-layout.scss'
})
export class SettingsLayout {

}
